var map = {
	"./0/Kambi/Header.mobile.layout": [
		14704,
		4105,
		2090
	],
	"./0/Kambi/Header.pc.layout": [
		99185,
		4105,
		8425
	],
	"./0/Kambi/HomeSection.layout": [
		48995,
		4105,
		7738
	],
	"./0/Kambi/SecondaryMenu.layout": [
		8017,
		4105,
		6277
	],
	"./0/Kambi/UsefulLinks.layout": [
		71360,
		4105,
		1539
	],
	"./0/Poker/Header.mobile.layout": [
		50289,
		4105,
		3673
	],
	"./0/Poker/Header.pc.layout": [
		36984,
		4105,
		3586
	],
	"./0/Poker/HomeSection.layout": [
		63170,
		4105,
		9345
	],
	"./0/Poker/LoyaltySection.layout": [
		73189,
		4105,
		4410
	],
	"./0/Poker/SecondaryMenu.layout": [
		4131,
		4105,
		1886
	],
	"./0/Poker/UsefulLinks.layout": [
		33017,
		4105,
		6804
	],
	"./0/Spectate/Header.mobile.layout": [
		74385,
		4105,
		273
	],
	"./0/Spectate/Header.pc.layout": [
		90744,
		4105,
		8474
	],
	"./0/Spectate/HomeSection.layout": [
		86434,
		4105,
		4521
	],
	"./0/Spectate/SecondaryMenu.layout": [
		33790,
		4105,
		7894
	],
	"./0/Spectate/UsefulLinks.layout": [
		60281,
		4105,
		3212
	],
	"./1/Kambi/Header.mobile.layout": [
		80853,
		4105,
		7906
	],
	"./1/Kambi/Header.pc.layout": [
		32940,
		4105,
		5310
	],
	"./1/Kambi/HomeSection.layout": [
		94398,
		4105,
		3237
	],
	"./1/Kambi/SecondaryMenu.layout": [
		21623,
		6266
	],
	"./1/Kambi/UsefulLinks.layout": [
		35397,
		4105,
		8456
	],
	"./1/Poker/Header.mobile.layout": [
		63688,
		4105,
		7822
	],
	"./1/Poker/Header.pc.layout": [
		13289,
		4105,
		4989
	],
	"./1/Poker/HomeSection.layout": [
		51835,
		4105,
		6774
	],
	"./1/Poker/LoyaltySection.layout": [
		78502,
		4105,
		4895
	],
	"./1/Poker/SecondaryMenu.layout": [
		83330,
		4105,
		5145
	],
	"./1/Poker/UsefulLinks.layout": [
		81512,
		4105,
		7935
	],
	"./1/Spectate/Header.mobile.layout": [
		56254,
		4105,
		6118
	],
	"./1/Spectate/Header.pc.layout": [
		14763,
		4105,
		4661
	],
	"./1/Spectate/HomeSection.layout": [
		75701,
		4105,
		9086
	],
	"./1/Spectate/SecondaryMenu.layout": [
		97680,
		4105,
		2593
	],
	"./1/Spectate/UsefulLinks.layout": [
		5650,
		4105,
		327
	],
	"./31/Kambi/Header.mobile.layout": [
		27720,
		4105,
		8010
	],
	"./31/Kambi/Header.pc.layout": [
		13975,
		4105,
		535,
		4329
	],
	"./31/Kambi/HomeSection.layout": [
		90011,
		4105,
		2410
	],
	"./31/Kambi/SecondaryMenu.layout": [
		38185,
		4105,
		837
	],
	"./31/Kambi/UsefulLinks.layout": [
		19688,
		4105,
		7059
	],
	"./31/Poker/Header.mobile.layout": [
		86201,
		4105,
		895
	],
	"./31/Poker/Header.pc.layout": [
		61696,
		4105,
		2636
	],
	"./31/Poker/HomeSection.layout": [
		3786,
		4105,
		5815
	],
	"./31/Poker/LoyaltySection.layout": [
		79997,
		4105,
		612
	],
	"./31/Poker/SecondaryMenu.layout": [
		38342,
		4105,
		3272
	],
	"./31/Poker/UsefulLinks.layout": [
		99409,
		4105,
		2946
	],
	"./31/Spectate/Header.mobile.layout": [
		15881,
		4105,
		2071
	],
	"./31/Spectate/Header.pc.layout": [
		72176,
		4105,
		535,
		1716
	],
	"./31/Spectate/HomeSection.layout": [
		88570,
		4105,
		4863
	],
	"./31/Spectate/SecondaryMenu.layout": [
		78059,
		4105,
		5120
	],
	"./31/Spectate/UsefulLinks.layout": [
		42049,
		4105,
		6762
	],
	"./58/Spectate/Header.mobile.layout": [
		17948,
		4105,
		6882
	],
	"./58/Spectate/Header.pc.layout": [
		24653,
		4105,
		8529
	],
	"./58/Spectate/HistorySection.layout": [
		89832,
		4105,
		1425
	],
	"./58/Spectate/HomeSection.layout": [
		47911,
		4105,
		9426
	],
	"./58/Spectate/SecondaryMenu.layout": [
		39885,
		4105,
		5021
	],
	"./58/Spectate/UsefulLinks.layout": [
		42084,
		4105,
		267
	],
	"./75/Kambi/Header.mobile.layout": [
		33440,
		4105,
		5858
	],
	"./75/Kambi/Header.pc.layout": [
		97121,
		4105,
		7569
	],
	"./75/Kambi/HomeSection.layout": [
		62195,
		4105,
		7010
	],
	"./75/Kambi/SecondaryMenu.layout": [
		66881,
		4105,
		7645
	],
	"./75/Kambi/UsefulLinks.layout": [
		99952,
		4105,
		7851
	],
	"./75/Spectate/Header.mobile.layout": [
		23713,
		4105,
		2487
	],
	"./75/Spectate/Header.pc.layout": [
		95272,
		4105,
		6884
	],
	"./75/Spectate/HomeSection.layout": [
		62258,
		4105,
		3231
	],
	"./75/Spectate/SecondaryMenu.layout": [
		97550,
		4105,
		4208
	],
	"./75/Spectate/UsefulLinks.layout": [
		1545,
		4105,
		5354
	],
	"./76/Kambi/Header.mobile.layout": [
		78187,
		4105,
		7047
	],
	"./76/Kambi/Header.pc.layout": [
		87030,
		4105,
		5284
	],
	"./76/Kambi/HomeSection.layout": [
		32416,
		4105,
		3791
	],
	"./76/Kambi/SecondaryMenu.layout": [
		81061,
		4105,
		6288
	],
	"./76/Kambi/UsefulLinks.layout": [
		80567,
		4105,
		1306
	],
	"./76/Spectate/Header.mobile.layout": [
		21024,
		4105,
		9026
	],
	"./76/Spectate/Header.pc.layout": [
		6305,
		4105,
		4273
	],
	"./76/Spectate/HomeSection.layout": [
		94835,
		4105,
		3842
	],
	"./76/Spectate/SecondaryMenu.layout": [
		5089,
		4105,
		7517
	],
	"./76/Spectate/UsefulLinks.layout": [
		32592,
		4105,
		9867
	],
	"./8/Poker/Header.mobile.layout": [
		1209,
		4105,
		705
	],
	"./8/Poker/Header.pc.layout": [
		55808,
		4105,
		3498
	],
	"./8/Poker/HomeSection.layout": [
		13834,
		4105,
		9657
	],
	"./8/Poker/LoyaltySection.layout": [
		70333,
		4105,
		6530
	],
	"./8/Poker/SecondaryMenu.layout": [
		23323,
		4105,
		2566
	],
	"./8/Poker/UsefulLinks.layout": [
		70225,
		4105,
		9228
	],
	"./8/Spectate/Header.mobile.layout": [
		77641,
		4105,
		7609
	],
	"./8/Spectate/Header.pc.layout": [
		38142,
		4105,
		3885,
		2658
	],
	"./8/Spectate/HistorySection.layout": [
		18615,
		4105,
		2588
	],
	"./8/Spectate/HomeSection.layout": [
		83866,
		4105,
		8465
	],
	"./8/Spectate/RegulationLogosSection.layout": [
		50019,
		6080
	],
	"./8/Spectate/SecondaryMenu.layout": [
		65881,
		4105,
		8792,
		1198
	],
	"./8/Spectate/UsefulLinks.layout": [
		81377,
		4105,
		6532
	],
	"./81/Kambi/Header.mobile.layout": [
		77741,
		4105,
		8165
	],
	"./81/Kambi/Header.pc.layout": [
		32772,
		4105,
		6256,
		4510
	],
	"./81/Kambi/HomeSection.layout": [
		70646,
		4105,
		7477
	],
	"./81/Kambi/SecondaryMenu.layout": [
		68634,
		4105,
		5866
	],
	"./81/Kambi/UsefulLinks.layout": [
		20941,
		4105,
		7016
	],
	"./81/Spectate/Header.mobile.layout": [
		97334,
		4105,
		632
	],
	"./81/Spectate/Header.pc.layout": [
		18787,
		4105,
		6256,
		115
	],
	"./81/Spectate/HomeSection.layout": [
		61325,
		4105,
		3152
	],
	"./81/Spectate/SecondaryMenu.layout": [
		85447,
		4105,
		6951
	],
	"./81/Spectate/UsefulLinks.layout": [
		45146,
		4105,
		9185
	],
	"./84/Kambi/Header.mobile.layout": [
		34500,
		4105,
		2926
	],
	"./84/Kambi/Header.pc.layout": [
		43989,
		7597
	],
	"./84/Kambi/HomeSection.layout": [
		49999,
		4105,
		7062
	],
	"./84/Kambi/SecondaryMenu.layout": [
		45614,
		4105,
		249
	],
	"./84/Kambi/UsefulLinks.layout": [
		93692,
		4105,
		8223
	],
	"./84/Spectate/Header.mobile.layout": [
		89301,
		4105,
		5455
	],
	"./84/Spectate/Header.pc.layout": [
		77100,
		4105,
		5964
	],
	"./84/Spectate/HomeSection.layout": [
		4145,
		4105,
		2087
	],
	"./84/Spectate/SecondaryMenu.layout": [
		16140,
		4105,
		4040
	],
	"./84/Spectate/UsefulLinks.layout": [
		59397,
		4105,
		4466
	],
	"./86/Spectate/Header.mobile.layout": [
		57823,
		4105,
		3365
	],
	"./86/Spectate/Header.pc.layout": [
		53074,
		4105,
		296,
		2414
	],
	"./86/Spectate/HomeSection.layout": [
		72540,
		4105,
		7525
	],
	"./86/Spectate/SILinks.mobile.layout": [
		82241,
		257
	],
	"./86/Spectate/SILinks.pc.layout": [
		25160,
		7338
	],
	"./86/Spectate/SecondaryMenu.layout": [
		41529,
		4105,
		1066
	],
	"./86/Spectate/UsefulLinks.layout": [
		97683,
		4105,
		7064
	],
	"./87/Spectate/Header.mobile.layout": [
		12500,
		4105,
		989
	],
	"./87/Spectate/Header.pc.layout": [
		84741,
		4105,
		6697
	],
	"./87/Spectate/HomeSection.layout": [
		86303,
		4105,
		7114
	],
	"./87/Spectate/SecondaryMenu.layout": [
		88894,
		4105,
		6229
	],
	"./87/Spectate/UsefulLinks.layout": [
		83500,
		4105,
		8915
	],
	"./88/Spectate/Header.mobile.layout": [
		62673,
		4105,
		4315
	],
	"./88/Spectate/Header.pc.layout": [
		13656,
		4105,
		1112
	],
	"./88/Spectate/HistorySection.layout": [
		35775,
		4105,
		5034
	],
	"./88/Spectate/HomeSection.layout": [
		93218,
		4105,
		2456
	],
	"./88/Spectate/SecondaryMenu.layout": [
		93507,
		4105,
		5412
	],
	"./88/Spectate/UsefulLinks.layout": [
		61209,
		4105,
		8902
	],
	"./89/Spectate/Header.mobile.layout": [
		35006,
		4105,
		5168
	],
	"./89/Spectate/Header.pc.layout": [
		77035,
		4105,
		296,
		3467
	],
	"./89/Spectate/HomeSection.layout": [
		78389,
		4105,
		4024
	],
	"./89/Spectate/SILinks.mobile.layout": [
		54922,
		3538
	],
	"./89/Spectate/SILinks.pc.layout": [
		39143,
		4865
	],
	"./89/Spectate/SecondaryMenu.layout": [
		84560,
		4105,
		1066,
		9423
	],
	"./89/Spectate/UsefulLinks.layout": [
		85458,
		4105,
		1961
	],
	"./90/Spectate/Header.mobile.layout": [
		35608,
		4105,
		5486
	],
	"./90/Spectate/Header.pc.layout": [
		86361,
		4105,
		296,
		1453
	],
	"./90/Spectate/HomeSection.layout": [
		69707,
		4105,
		1606
	],
	"./90/Spectate/SILinks.mobile.layout": [
		19508,
		8008
	],
	"./90/Spectate/SILinks.pc.layout": [
		23109,
		4515
	],
	"./90/Spectate/SecondaryMenu.layout": [
		27186,
		4105,
		1066,
		5817
	],
	"./90/Spectate/UsefulLinks.layout": [
		1496,
		4105,
		799
	],
	"./91/Spectate/Header.mobile.layout": [
		3651,
		4105,
		7113
	],
	"./91/Spectate/Header.pc.layout": [
		39246,
		4105,
		296,
		4194
	],
	"./91/Spectate/HomeSection.layout": [
		76184,
		4105,
		5617
	],
	"./91/Spectate/LeftHeader.pc.layout": [
		77855,
		8469
	],
	"./91/Spectate/SILinks.mobile.layout": [
		26517,
		9237
	],
	"./91/Spectate/SILinks.pc.layout": [
		19404,
		1806
	],
	"./91/Spectate/SecondaryMenu.layout": [
		71917,
		4105,
		1066,
		398
	],
	"./91/Spectate/UsefulLinks.layout": [
		66399,
		4105,
		1204
	],
	"./92/Spectate/Header.mobile.layout": [
		20646,
		4105,
		4872
	],
	"./92/Spectate/Header.pc.layout": [
		85491,
		4105,
		9139
	],
	"./92/Spectate/HomeSection.layout": [
		39549,
		4105,
		4960
	],
	"./92/Spectate/LeftHeader.pc.layout": [
		56526,
		38
	],
	"./92/Spectate/SecondaryMenu.layout": [
		29860,
		4105,
		2916
	],
	"./92/Spectate/UsefulLinks.layout": [
		27818,
		4105,
		8017
	],
	"./94/Spectate/Header.mobile.layout": [
		31108,
		4105,
		2426
	],
	"./94/Spectate/Header.pc.layout": [
		94933,
		4105,
		8918
	],
	"./94/Spectate/HomeSection.layout": [
		82927,
		4105,
		2314
	],
	"./94/Spectate/LeftHeader.pc.layout": [
		58788,
		9392
	],
	"./94/Spectate/SecondaryMenu.layout": [
		58521,
		4105,
		9301
	],
	"./94/Spectate/UsefulLinks.layout": [
		37084,
		4105,
		499
	],
	"./95/Spectate/Header.mobile.layout": [
		40175,
		4105,
		2773
	],
	"./95/Spectate/Header.pc.layout": [
		86730,
		4105,
		478
	],
	"./95/Spectate/HomeSection.layout": [
		41068,
		4105,
		4181
	],
	"./95/Spectate/LeftHeader.pc.layout": [
		6139,
		2533
	],
	"./95/Spectate/SecondaryMenu.layout": [
		71636,
		4105,
		9578
	],
	"./95/Spectate/UsefulLinks.layout": [
		31235,
		4105,
		2360
	],
	"./96/Poker/Header.mobile.layout": [
		21092,
		4105,
		908
	],
	"./96/Poker/Header.pc.layout": [
		71189,
		4105,
		9447
	],
	"./96/Poker/HomeSection.layout": [
		92431,
		4105,
		8860
	],
	"./96/Poker/LoyaltySection.layout": [
		69834,
		4105,
		9929
	],
	"./96/Poker/SecondaryMenu.layout": [
		91694,
		4105,
		7419
	],
	"./96/Poker/UsefulLinks.layout": [
		26908,
		4105,
		5869
	],
	"./96/Spectate/Header.mobile.layout": [
		11170,
		4105,
		4212
	],
	"./96/Spectate/Header.pc.layout": [
		77919,
		4105,
		3885,
		111
	],
	"./96/Spectate/HistorySection.layout": [
		29590,
		4105,
		7439
	],
	"./96/Spectate/HomeSection.layout": [
		27617,
		4105,
		5636
	],
	"./96/Spectate/RegulationLogosSection.layout": [
		87218,
		8619
	],
	"./96/Spectate/SecondaryMenu.layout": [
		45780,
		4105,
		8792,
		8979
	],
	"./96/Spectate/UsefulLinks.layout": [
		90670,
		4105,
		965
	],
	"./default/Kambi/Header.mobile.layout": [
		94143,
		4105,
		8867
	],
	"./default/Kambi/Header.pc.layout": [
		33658,
		1216
	],
	"./default/Kambi/HomeSection.layout": [
		30012,
		4105,
		7315
	],
	"./default/Spectate/Header.mobile.layout": [
		55812,
		4105,
		60
	],
	"./default/Spectate/Header.pc.layout": [
		48245,
		6759
	],
	"./default/Spectate/HomeSection.layout": [
		70767,
		4105,
		2364
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 37091;
module.exports = webpackAsyncContext;